import React from "react";
import _ from "lodash";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import {
  ProductNutritionCategory,
  ProductNutritionMeasurement
} from "src/core/products/api/products.api";

export interface ProductNutritionValuesTableRowProps {
  category: ProductNutritionCategory | "Energy";
  per100: number | string;
  perItem: number | string;
  measurement?: ProductNutritionMeasurement;
}

/**
 * Renders a table row specifically for product nutrition values table.
 */
const ProductNutritionValuesTableRow: React.ReactFCWithChildren<ProductNutritionValuesTableRowProps> = ({
  category,
  measurement,
  per100,
  perItem
}) => {
  const indented = (category === ProductNutritionCategory.Sugars || category === ProductNutritionCategory.Saturates);

  return (
    <TableRowStyled>
      <td className="table-data-field">
        <Text
          className={`table-data-text ${indented ? "indented" : ""}`}
          weight="light"
        >
          {indented ? `of which ${category}` : _.capitalize(category)}
        </Text>
      </td>

      <td className="table-data-field borderLeft">
        <Text
          className="table-data-text"
          weight="light"
        >
          {`${per100}${measurement || ""}`}
        </Text>
      </td>

      <td className="table-data-field borderLeft">
        <Text
          className="table-data-text"
          weight="light"
        >
          {`${perItem}${measurement || ""}`}
        </Text>
      </td>
    </TableRowStyled>
  );
};

export const TableRowStyled = styled.tr`
  ${({ theme }) => css`
    border-bottom: 1px solid black;
    width: 100%;
    
    .table-data-field {
      text-align: left;
      border-left: 0 solid black;
    }
    
    .borderLeft {
      border-left: 1px solid black;
    }
    
    .table-data-text {
      margin-left: ${theme.spacing.margins.xs};
    }
    
    .indented {
      margin-left: ${theme.spacing.margins.sm};
    }
  `}
`;

export default ProductNutritionValuesTableRow;
